export { default } from './TagBadge';
